module.exports = __webpack_public_path__ + "dist/assets/c42d0345c90d91abbed33e4475c23901.svg";